<div class="col-md-12 text-left">
  <div class="row content-block">
    <select
      class="form-control"
      name="item"
      (change)="onChange($event.target.value)"
      (focus)="onFocus()"
    >
      <option [value]="undefined" [disabled]="isFocused" *ngIf="placeholder">
        {{ placeholder }}
      </option>
      <option
        [value]="item.value"
        [selected]="item.value.toString() === selected"
        *ngFor="let item of items"
      >
        {{ item.label }}
      </option>
    </select>
  </div>
</div>
